import { ReportTemplate } from './types';

export const DEFAULT_TEMPLATES_UK: ReportTemplate[] = [
  {
    id: 'scientific',
    name: 'Науково-технічний шаблон',
    description: 'Ідеально підходить для огляду фізичних, інженерних або програмних досліджень з глибокою методологією.',
    styleAccent: 'cyan',
    sections: [
      { id: 'intro', title: '1. Вступ та контекст дослідження', description: 'Обґрунтування актуальності теми, передісторія технології та формулювання проблеми.', enabled: true },
      { id: 'method', title: '2. Методологія та межі аналізу', description: 'Опис джерел, критеріїв верифікації фактів та обмежень моделювання.', enabled: true },
      { id: 'findings', title: '3. Основні технологічні висновки', description: 'Ключові відкриття, експериментальні дані, інноваційні концепти та їх обґрунтування.', enabled: true },
      { id: 'visuals', title: '4. Аналітичні візуалізації даних', description: 'Детальний аналіз графіків, статистичних таблиць та візуалізованих взаємозв\'язків.', enabled: true },
      { id: 'conclusion', title: '5. Висновок та науково-технічні перспективи', description: 'Підсумкове резюме, прогнози розвитку та стратегічні рекомендації.', enabled: true }
    ]
  },
  {
    id: 'financial',
    name: 'Фінансово-ринковий шаблон',
    description: 'Оптимізовано для комерційних звітів, аналізу ринків, компаній, ризиків та SWOT.',
    styleAccent: 'amber',
    sections: [
      { id: 'intro', title: '1. Резюме для інвесторів (Executive Brief)', description: 'Стисла вижимка ключових ринкових індикаторів, обсягів ринків та інвестиційних можливостей.', enabled: true },
      { id: 'method', title: '2. Ринковий контекст та гравці', description: 'Аналіз конкурентного середовища, розподіл часток ринку та ланцюжків створення вартості.', enabled: true },
      { id: 'findings', title: '3. Ключеві фінансово-економічні інсайти', description: 'Числові показники прибутковості, обсяги продажів, динаміка зростання акцій та капіталізації.', enabled: true },
      { id: 'visuals', title: '4. Діаграми часток та динаміки ринку', description: 'Інтерпретація розподілу часток, обсягів та відсоткових співвідношень.', enabled: true },
      { id: 'swot', title: '5. Стратегічний SWOT-аналіз ризиків', description: 'Матриця сильних/слабких сторін, перспектив зростання та регуляторних/ринкових загроз.', enabled: true },
      { id: 'conclusion', title: '6. Фінансовий прогноз та рекомендації', description: 'Прогнози ринкових трендів, оцінка окупності та рекомендації щодо входу.', enabled: true }
    ]
  },
  {
    id: 'general',
    name: 'Загальний аналітичний шаблон',
    description: 'Збалансований шаблон для будь-яких соціально-економічних або загальногуманітарних досліджень.',
    styleAccent: 'emerald',
    sections: [
      { id: 'intro', title: '1. Вступ', description: 'Загальний опис теми дослідження та її соціальної чи економічної ролі.', enabled: true },
      { id: 'method', title: '2. Використовувані дані та підходи', description: 'Огляд підходів до аналізу інформації та основні припущення.', enabled: true },
      { id: 'trends', title: '3. Виявлені тренди та закономірності', description: 'Ключові факти, зміни в часі та причинно-наслідкові зв\'язки.', enabled: true },
      { id: 'visuals', title: '4. Статистичні дані та діаграми', description: 'Опис числової структури даних у вигляді діаграм та їх розшифровка.', enabled: true },
      { id: 'conclusion', title: '5. Висновки та подальші кроки', description: 'Підсумкові судження, узагальнення та конкретні рекомендації до дії.', enabled: true }
    ]
  }
];

export const DEFAULT_TEMPLATES_EN: ReportTemplate[] = [
  {
    id: 'scientific',
    name: 'Scientific & Technical Template',
    description: 'Perfect for deep-dive physical, engineering, or software investigations with explicit methodology.',
    styleAccent: 'cyan',
    sections: [
      { id: 'intro', title: '1. Introduction and Context', description: 'Rationale of the topic, technological background, and problem definition.', enabled: true },
      { id: 'method', title: '2. Research Methodology & Limits', description: 'Description of cited sources, verification criteria, and logical boundaries.', enabled: true },
      { id: 'findings', title: '3. Core Technological Findings', description: 'Key innovations, experimental data, cutting-edge discoveries, and theoretical proof.', enabled: true },
      { id: 'visuals', title: '4. Analytical Data Visualizations', description: 'Detailed interpretation of numerical tables, metrics, and generated charts.', enabled: true },
      { id: 'conclusion', title: '5. Conclusion & Strategic Outlook', description: 'Final summary, developmental forecasts, and technical recommendations.', enabled: true }
    ]
  },
  {
    id: 'financial',
    name: 'Financial & Market Template',
    description: 'Optimized for commercial research, market sizing, competitor analysis, and SWOT matrix.',
    styleAccent: 'amber',
    sections: [
      { id: 'intro', title: '1. Investor Executive Brief', description: 'Condensed summary of key market metrics, absolute values, and opportunities.', enabled: true },
      { id: 'method', title: '2. Competitive Context & Value Chains', description: 'Analysis of competitors, market share distributions, and production constraints.', enabled: true },
      { id: 'findings', title: '3. Core Economic & Financial Insights', description: 'Yield numbers, revenues, costs, CAGR growth dynamics, and valuations.', enabled: true },
      { id: 'visuals', title: '4. Share Breakdowns & Charts', description: 'Interpretation of market shares, temporal dynamics, and percentages.', enabled: true },
      { id: 'swot', title: '5. Strategic SWOT Matrix', description: 'Strengths, weaknesses, external opportunities, and market/regulatory threats.', enabled: true },
      { id: 'conclusion', title: '6. Forecast & Investment Rationale', description: 'Future market forecast, NPV/payback indications, and final advisory.', enabled: true }
    ]
  },
  {
    id: 'general',
    name: 'General Analytical Template',
    description: 'Balanced layout for socio-economic, political, or miscellaneous general research topics.',
    styleAccent: 'emerald',
    sections: [
      { id: 'intro', title: '1. Introduction', description: 'High-level description of the study topic and its social or economic role.', enabled: true },
      { id: 'method', title: '2. Scope & Analytical Approach', description: 'Overview of standard methods used to process information and clear assumptions.', enabled: true },
      { id: 'trends', title: '3. Discovered Trends & Insights', description: 'Key historical changes, consensus findings, and cause-effect chains.', enabled: true },
      { id: 'visuals', title: '4. Statistical Data & Metrics', description: 'Detailed statistical table breakdown and graphic chart interpretation.', enabled: true },
      { id: 'conclusion', title: '5. Analytical Conclusions & Action Points', description: 'Final summary, strategic takeaways, and concrete recommended decisions.', enabled: true }
    ]
  }
];
